// extracted by mini-css-extract-plugin
module.exports = {"base":"opinionStoryCard-m__base__1MS7P","story-details":"opinionStoryCard-m__story-details__1xt0f"};